// ahora guardamos 02libro y trabajamos sobre este en limpio
// borrad los comentarios e ir a linea 275

import React,{Component} from 'react';
import {variables} from './Variables.js';

export class Libro extends Component{
    
    constructor(props){
        super(props);
        this.state={

            generos:[],
            libros:[],
            modalTitle:"",
            libroid:0,
            librotitulo:"",
            libroautor:"",
            genero:""
          //  portadalibro:"anonymous.png",
         //   PhotoPath:variables.PHOTO_URL

        }
    }
    refreshList(){
        fetch(variables.API_URL+'libros')
        .then(response=>response.json())
        .then(data=>{
            console.log(data)
            this.setState({libros:data});
        });
        fetch(variables.API_URL+'generos')
        .then(response=>response.json())
        .then(data=>{
            //console.log(data)
            this.setState({generos:data});
        });
    }
    componentDidMount(){
        this.refreshList();
     }
changeLibroTitulo =(e)=>{
    this.setState({librotitulo:e.target.value});
}

changeLibroAutor =(e)=>{
    this.setState({libroautor:e.target.value});
}

changeGenero =(e)=>{
    this.setState({genero:e.target.value});
}
addClick(){
    this.setState({
        modalTitle:"Añade libro",
        libroid:0,
        librotitulo:"",
        libroautor:"",
        genero:""
    //    portadalibro:"anonymous.png",
    });
}
editClick(lib){
    this.setState({
        modalTitle:"Edita libro",
        libroid:lib.libroid,
        librotitulo:lib.librotitulo,
        libroautor:lib.libroautor,
        genero:lib.genero
     //   portadalibro:lib.portadalibro
    });
}


createClick(){

    fetch(variables.API_URL+'libros',{
        method:'POST',
        headers:{
            'Accept':'application/json',
            'Content-Type':'application/json'
        },
       
        body:JSON.stringify({
            librotitulo:this.state.librotitulo,
            libroautor:this.state.libroautor,
            genero:this.state.genero
       //     portadalibro:this.state.portadalibro
        })
    })
    .then(res=>res.json())
    .then(res=>console.log(res))
    .then((result)=>{
        alert("refresque pantalla");

        this.refreshList();
    },(error)=>{
        alert('creado');
        this.refreshList();
    })
}


updateClick(){
    fetch(variables.API_URL+'libros',{
        method:'PUT',
        headers:{
            'Accept':'application/json',
            'Content-Type':'application/json'
        },
        body:JSON.stringify({
            libroid:this.state.libroid,
            librotitulo:this.state.librotitulo,
            libroautor:this.state.libroautor,
            genero:this.state.genero
        //    portadalibro:this.state.portadalibro
        })
    })
    .then(res=>res.json())
    .then((res)=>{
        alert("refresque pantalla");
        this.refreshList();
    },(error)=>{
        alert('actualizado');
        this.refreshList();
    })
}
deleteClick(lib){
    if(window.confirm('¿Estás segura/o?')){
        // this.setState({
        //     modalTitle:"borra libro",
        //     libroid:lib.libroid
        // });
    fetch(variables.API_URL+'libros',{
        method:'DELETE',
        headers:{
            'Accept':'application/json',
            'Content-Type':'application/json'
        },
        body:JSON.stringify({
            libroid:lib.libroid
        })
    })
    .then(res=>res.json())
    .then((res)=>{
        alert("refresca pantalla");
        this.refreshList();
    },(error)=>{
        alert("eliminado");
        this.refreshList();
    })
    }
}

// aquí definimos el cambio de imagen cuando se sube una
// imageUpload=(e)=>{
//     e.preventDefault();
// // hay que crear un formData y adjuntarle el archivo que se elige
//     const formData=new FormData();
//     formData.append("file",e.target.files[0],e.target.files[0].name);

//     fetch(variables.API_URL+'libro/savefile',{
//         method:'POST',
//         body:formData
//     })
//     .then(res=>res.json())
//     .then(data=>{
 
//         this.setState({PortadaLibro:data});
//     })
// }
   
    render(){

const {
    generos,
    libros,
    modalTitle,
    libroid,
    librotitulo,
    libroautor,
    genero
    // PhotoPath,
    // portadalibro

}=this.state;


        return(

            <div>
    <button type="button"
    className="btn btn-primary m-2 float-end"
    data-bs-toggle="modal"
    data-bs-target="#exampleModal"
    onClick={()=>this.addClick()}>
        Añadir Libro
    </button>
<table className="table table-striped">
    <thead>
    <tr>
        <th>            
            LibroId
        </th>
        <th>
            LibroTítulo     
        </th>
        <th>
            LibroAutor     
        </th>
        <th>
            Genero     
        </th>
        <th>
            Opciones
        </th>
    </tr>
    </thead>
    <tbody>
        {libros.map((lib)=>
            <tr key={lib.libroid}>
                <td>{lib.libroid}</td>
                <td>{lib.librotitulo}</td>
                <td>{lib.libroautor}</td>
                <td>{lib.genero}</td>
                <td>
                <button type="button"
                className="btn btn-light mr-1"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                onClick={()=>this.editClick(lib)}
                >

                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                     <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                     </svg>
                </button>

                <button type="button"
                className="btn btn-light mr-1"
                data-bs-target="#exampleModal"
                 onClick={()=>this.deleteClick(lib)}
                >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/>
                        </svg>
                </button>

                </td>
            </tr>
            )}
    </tbody>
    </table>
  <div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
<div className="modal-dialog modal-lg modal-dialog-centered">
<div className="modal-content">
   <div className="modal-header">
       <h5 className="modal-title">{modalTitle}</h5>
       <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"
       ></button>
   </div>
   <div className="modal-body">
    <div className="d-flex flex-row bd-highlight mb-3">    
    
     <div className="p-2 w-50 bd-highlight">

       <div className="input-group mb-3">
        <span className="input-group-text">LibroTitulo</span>
        <input type="text" className="form-control"
        name="librotitulo"
        defaultValue={librotitulo}
        onChange={this.changeLibroTitulo}/>
       </div>

       <div className="input-group mb-3">
        <span className="input-group-text">LibroAutor</span>
        <input type="text" className="form-control"
        name="libroautor"
        defaultValue={libroautor}
        onChange={this.changeLibroAutor}/>
       </div>

       <div className="input-group mb-3">
        <span className="input-group-text">Genero</span>
        <select className="form-select"
        name="genero"
            onChange={this.changeGenero}
            defaultValue={genero}>
                {generos.map(dep=><option key={dep.generoid}>
                    {dep.generonombre}
                </option>)}
            </select> 
       </div>

       </div>
       {/* <div className="p-2 w-50 bd-highlight">
         <img width="250px" height="250px"
         src={PhotoPath+portadalibro}/>

         <input className="m-2" type="file" onChange={this.imageUpload}/>

     </div> */}

     </div>
        {libroid===0?
        <button type="button"
        className="btn btn-primary float-start"
        onClick={()=>this.createClick()}
        >Crear</button>
        :null}
        {libroid!==0?
        <button type="button"
        className="btn btn-primary float-start"
        onClick={()=>this.updateClick()}
        >Actualizar</button>
        :null}


</div>
</div>
</div> 
</div>
            </div>
        )
    }
}
